"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Project = require("./Project");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * CarouselCell - Composant carrousel responsive
 */const CarouselCell = ({
  items = [],
  interval = 5000,
  loop = true,
  autoplay = true,
  controls = true,
  indicators = true,
  styles_properties = {},
  className = '',
  style = {},
  onSlideChange,
  onItemClick,
  onActionLog,
  uri_transformer = url => url,
  ...rest
}) => {
  const projectContext = (0, _react.useContext)(_Project.ProjectContext);
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(0);
  const [isPaused, setIsPaused] = (0, _react.useState)(false);
  const autoplayRef = (0, _react.useRef)(null);
  const totalSlides = items.length;

  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    opacity: styles_properties.opacity,
    ...style
  };

  // Navigation
  const goToSlide = (0, _react.useCallback)(index => {
    let newIndex = index;
    if (loop) {
      if (index < 0) newIndex = totalSlides - 1;
      if (index >= totalSlides) newIndex = 0;
    } else {
      if (index < 0) newIndex = 0;
      if (index >= totalSlides) newIndex = totalSlides - 1;
    }
    setCurrentIndex(newIndex);
    if (onSlideChange) {
      onSlideChange(newIndex, items[newIndex]);
    }
  }, [loop, totalSlides, onSlideChange, items]);
  const goToNext = (0, _react.useCallback)(() => {
    goToSlide(currentIndex + 1);
  }, [currentIndex, goToSlide]);
  const goToPrev = (0, _react.useCallback)(() => {
    goToSlide(currentIndex - 1);
  }, [currentIndex, goToSlide]);

  // Autoplay
  (0, _react.useEffect)(() => {
    if (autoplay && !isPaused && totalSlides > 1) {
      autoplayRef.current = setInterval(goToNext, interval);
    }
    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
      }
    };
  }, [autoplay, isPaused, interval, goToNext, totalSlides]);

  // Gestion du clic sur un item
  const handleItemClick = (item, e) => {
    // Log de l'action
    if (item.action_log && onActionLog) {
      onActionLog(item.action_log);
    }

    // Callback personnalisé
    if (onItemClick) {
      onItemClick(item, e);
      return;
    }

    // Navigation interne via le contexte (avec animation fade)
    if (item.link_to) {
      if (item.link_to.startsWith('http://') || item.link_to.startsWith('https://')) {
        window.open(item.link_to, '_blank');
      } else if (projectContext?.navigateToPage) {
        projectContext.navigateToPage(item.link_to);
      }
    }
  };

  // Styles pour un slide
  const getSlideStyle = item => {
    const props = item.styles_properties || {};
    return {
      backgroundColor: props.background_color,
      color: props.text_color,
      fontSize: props.text_size ? `${props.text_size}px` : undefined,
      fontFamily: props.text_font,
      padding: props.padding ? `${props.padding}px` : undefined,
      opacity: props.opacity
    };
  };

  // Rendu d'un slide
  const renderSlide = (item, index) => {
    const slideStyle = getSlideStyle(item);
    const isClickable = !!(item.link_to || onItemClick);
    const slideContent = () => {
      switch (item.type) {
        case 'image':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "carousel-cell__slide-image",
            src: uri_transformer(item.image_uri),
            alt: item.text || `Slide ${index + 1}`
          });
        case 'video':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("video", {
            className: "carousel-cell__slide-video",
            src: uri_transformer(item.video_uri),
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true
          });
        case 'text':
        default:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "carousel-cell__slide-text",
            style: slideStyle,
            children: item.text
          });
      }
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "carousel-cell__slide",
      style: {
        ...slideStyle,
        cursor: isClickable ? 'pointer' : 'default'
      },
      onClick: isClickable ? e => handleItemClick(item, e) : undefined,
      "data-action-log": item.action_log,
      children: slideContent()
    }, item.id);
  };
  const containerClasses = ['carousel-cell', className].filter(Boolean).join(' ');
  if (totalSlides === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: containerClasses,
      style: containerStyle,
      ...rest,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          color: '#666'
        },
        children: "Aucun \xE9l\xE9ment \xE0 afficher"
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: containerClasses,
    style: containerStyle,
    onMouseEnter: () => setIsPaused(true),
    onMouseLeave: () => setIsPaused(false),
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "carousel-cell__track",
      style: {
        transform: `translateX(-${currentIndex * 100}%)`
      },
      children: items.map((item, index) => renderSlide(item, index))
    }), controls && totalSlides > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "carousel-cell__controls",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "carousel-cell__control carousel-cell__control--prev",
        onClick: goToPrev,
        "aria-label": "Pr\xE9c\xE9dent",
        children: "\u2039"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "carousel-cell__control carousel-cell__control--next",
        onClick: goToNext,
        "aria-label": "Suivant",
        children: "\u203A"
      })]
    }), indicators && totalSlides > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "carousel-cell__indicators",
      children: items.map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: `carousel-cell__indicator ${index === currentIndex ? 'carousel-cell__indicator--active' : ''}`,
        onClick: () => goToSlide(index),
        "aria-label": `Aller au slide ${index + 1}`
      }, index))
    })]
  });
};
var _default = exports.default = CarouselCell;